export const headCells = [
  {
    id: "id",
    numeric: false,
    disablePadding: true,
    label: "S.no",
  },
  {
    id: "consultantName",
    numeric: false,
    disablePadding: true,
    label: "Consultant Name",
  },
  {
    id: "customerName",
    numeric: true,
    disablePadding: false,
    label: "Customer Name",
  },
  {
    id: "branchName",
    numeric: true,
    disablePadding: false,
    label: "Branch Name",
  },
  {
    id: "appointmentDate",
    numeric: true,
    disablePadding: false,
    label: "Appointment Date",
  },
  {
    id: "appointmentTime",
    numeric: true,
    disablePadding: false,
    label: "Appointment Time",
  },
  {
    id: "appointmentCreatedAt",
    numeric: true,
    disablePadding: false,
    label: "Appointment Created",
  },
  {
    id: "consultantFee",
    numeric: true,
    disablePadding: false,
    label: "Consultant Fee(₹)",
  },
  {
    id: "paymentStatus",
    numeric: true,
    disablePadding: false,
    label: "Payment Status",
  },
  {
    id: "status",
    numeric: true,
    disablePadding: false,
    label: "Status",
  },
];
